import PropTypes from 'prop-types';
import ImageProp from '../../../commonComponents/propTypes/imageProp';
import { QUESTION_STATUSES } from '../../../services/utilityFunctions';

const propType = {
  _id: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  image: PropTypes.shape(ImageProp.propType),
  answers: PropTypes.objectOf(PropTypes.string),
  correctAnswer: PropTypes.string.isRequired,
  status: PropTypes.oneOf(QUESTION_STATUSES),
};

export default { propType };
